<div class="dialog-container">
  <h2 mat-dialog-title>Add Sub-Todo</h2>
  <mat-dialog-content>
    <form [formGroup]="subtodoForm" (ngSubmit)="onSubmit()">
      <mat-form-field class="w-100">
        <mat-label>Description</mat-label>
        <textarea matInput formControlName="description" placeholder="Enter sub-todo description" rows="3" required></textarea>
        <mat-error *ngIf="subtodoForm.get('description')?.hasError('required')">
          Description is required
        </mat-error>
      </mat-form-field>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!subtodoForm.valid || isSubmitting">
      <span *ngIf="!isSubmitting">Save</span>
      <span *ngIf="isSubmitting">Saving...</span>
    </button>
  </mat-dialog-actions>
</div>
